export default __webpack_public_path__ + "static/media/trucking.abaaf5ad.png";